import React from 'react';
import CardList from 'components/card-list';
import {useOffersContext} from 'providers/offers-context';
import {IOfferItem} from 'types/offers';
import {useFilterContext} from 'providers/filter-context';
import NoData from 'components/no-data';
import { QUERY_KEYS } from '../../../constants';
import { useQuery } from 'react-query';

/**
 * This component is used in the offer details page as a background list.
 * Main goal of it is mainly to provide a consistent user experience.
 * It shows the same list of offers that was visible on the main offers page.
 * 
 * Key features:
 * - Uses cached data from context or show empty list
 * - Maintains consistency with the main offers view
 */
const List: React.FC = () => {
  // Get filter type from context (though not used in this background list)
  const {filterType} = useFilterContext();
  // Get offers list and setter from context for caching
  const {offersList} = useOffersContext();

  // Check if any filters are selected
  const hasSelectedFilters = Object.values(filterType).some(value => value);

  // Get cached offers list without making new requests
  const {data: cachedData} = useQuery<IOfferItem[]>(
    [QUERY_KEYS.OFFERS.LIST, filterType],
    () => [], // This function will never run because enabled is false
    {
      enabled: false // Only read from cache - never make requests
    }
  );

  // If no filters are selected, show a message
  if (!hasSelectedFilters) {
    return <NoData message="Please select at least one device type to see offers" />;
  }

  // Use cached data if context data is empty, otherwise use context data
  return <CardList<IOfferItem[]> data={(offersList?.length ? offersList : cachedData) || []} isFetching={false} />;
};

export default List;
